"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardElement = void 0;

var _styledComponents = require("styled-components");

var _mediaQuery = _interopRequireDefault(require("../../utils/mediaQuery"));

var _defaultTheme = _interopRequireDefault(require("../../defaultTheme"));

var _borders = require("./borders");

var CardElement = (0, _styledComponents.css)(["width:100%;box-sizing:border-box;position:relative;box-shadow:", ";border-top:", ";background:", ";", ""], function (_ref) {
  var expanded = _ref.expanded,
      theme = _ref.theme;
  return expanded && theme.orbit.boxShadowActionActive;
}, function (_ref2) {
  var expanded = _ref2.expanded;
  return !expanded && _borders.getBorder;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.orbit.backgroundCard;
}, _mediaQuery.default.largeMobile((0, _styledComponents.css)(["border-left:", ";border-right:", ";"], function (_ref4) {
  var expanded = _ref4.expanded;
  return !expanded && _borders.getBorder;
}, function (_ref5) {
  var expanded = _ref5.expanded;
  return !expanded && _borders.getBorder;
})));
exports.CardElement = CardElement;
CardElement.defaultProps = {
  theme: _defaultTheme.default
};